import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_YEF_DATE } from './queries';
import { LoadingPlaceholder } from '../client-web-app/components';
import YearEndFinancialLabel from './yearEndFinancialLabel';

type Document = {
  displayName: string | undefined;
  taxDocumentType: string | undefined;
  documentDate: string | undefined;
};

const LastYEFDate = (props: { clientId: string }) => {
  const { clientId } = props;
  const { loading, error, data } = useQuery(GET_YEF_DATE, {
    variables: { clientId },
  });
  if (error) {
    return <div>{error.message}</div>;
  }
  if (loading) {
    return <LoadingPlaceholder minHeight={10} />;
  }
  const getYEFDate = {
    data: data?.getYEFDate,
  };
  const latestYEF = getLastYEF(getYEFDate?.data?.results);
  const text = `Last YEF date: ${latestYEF?.documentDate || 'Does Not Exist'}`;

  return <YearEndFinancialLabel text={text} />;
};

function getLastYEF(documents: Document[]) {
  const filteredDocuments = documents.filter(doc => doc.taxDocumentType === 'YEF');
  filteredDocuments.sort((a, b) => {
    const dateA = a.documentDate ? new Date(a.documentDate) : undefined;
    const dateB = b.documentDate ? new Date(b.documentDate) : undefined;
    return dateB && dateA ? dateB.getTime() - dateA.getTime() : 0;
  });
  const latestYEF = filteredDocuments && filteredDocuments[0];
  return latestYEF;
}

export default LastYEFDate;
